// $(window).scroll(function() {
//   if ($(this).scrollTop() > 180){
//     $('header').addClass("shrink");
//   }
//   else{
//     $('header').removeClass("shrink");
//   }
// });

$(".bnr_slider").slick({
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: false,
  speed: 500,
  autoplay: true,
  autoplaySpeed: 6000,
});

$(".testimonial_slider").slick({
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  speed: 500,
  // autoplay: true,
  // autoplaySpeed: 6000
});

$(".history_about_slider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  asNavFor: ".history_date_slider",
});
$(".history_date_slider").slick({
  slidesToShow: 7,
  slidesToScroll: 1,
  asNavFor: ".history_about_slider",
  dots: false,
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 1180,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
      },
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
  ],
});

$(".value_slider").slick({
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: false,
  focusOnSelect: true,
  asNavFor: '.values_content_slider'
});

$('.values_content_slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  asNavFor: '.value_slider',
  dots: false,
  arrows: false
});